import { ReactNode } from 'react'
import { create } from 'jss'
import { createGenerateClassName, StylesProvider, jssPreset } from '@mui/styles'

const jss = create({ ...jssPreset() })
// MUI v4 has its own generator. Keep v5 production classes out of its jssN namespace.
const generateClassName = createGenerateClassName({ seed: 'cliniter-v5' })

export default function AppStylesProvider({ children }: { children: ReactNode }) {
  return <StylesProvider injectFirst jss={jss} generateClassName={generateClassName}>{children}</StylesProvider>
}
